<template>
  <page size="is-xlarge" :title="$tc('dashboard.web.title')">
    <div slot="page-header-right">
      <div style="display: flex; align-items: center">
        <div class="mr-4">
          {{ $t("date.range") }}:
          <strong>{{ timeLabel }}</strong>
        </div>

        <charting-time-options
          only-day-interval
          @submit="onSubmitNewTime"
        ></charting-time-options>
      </div>
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-3 is-parent">
        <visitors-total-count class="tile is-child"></visitors-total-count>
      </div>

      <div class="tile is-9 is-parent">
        <div class="box tile is-child has-text-centered pt-8 has-text-grey">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>
            <slot>{{ $t("empty") }}</slot>
          </p>
        </div>
      </div>
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-6 is-parent">
        <div class="box tile is-child">
          <p class="title is-5">{{ $t("dashboard.web.guests_and_views") }}</p>

          <chart
            type="bar"
            data-url="/admin/api/web/analytics/total-visitors-page-views"
            :params="{ date_range: dateRange }"
          ></chart>
        </div>
      </div>

      <div class="tile is-6 is-parent">
        <most-visited-pages class="tile is-child"></most-visited-pages>
      </div>
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-6 is-parent">
        <top-referrers class="tile is-child"></top-referrers>
      </div>

      <div class="tile is-6 is-parent">
        <div class="box tile is-child">
          <p class="title is-5">{{ $tc("browser", 2) }}</p>

          <chart
            type="pie"
            data-url="/admin/api/web/analytics/top-browsers"
            :params="{ date_range: dateRange }"
          ></chart>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import Chart from "../../../../components/Chart";
import ChartingTimeOptions from "../../../../components/ChartingTimeOptions";

import MostVisitedPages from "./MostVisitedPages";
import TopReferrers from "./TopReferrers";
import VisitorsTotalCount from "./VisitorsTotalCount";

export default {
  components: {
    Chart,
    ChartingTimeOptions,

    MostVisitedPages,
    TopReferrers,
    VisitorsTotalCount,
  },

  computed: {
    dateRange() {
      return this.$route.query.date_range ? this.$route.query.date_range : null;
    },

    timeLabel() {
      switch (this.dateRange) {
        case "last_15_days":
          return "Last 15 days";
        case "today":
          return "Today";
        case "yesterday":
          return "Yesterday";
        case "this_week":
          return "This week";
        case "last_week":
          return "Last week";
        case "this_month":
          return "This month";
        case "last_month":
          return "Last month";
        case "this_year":
          return "This year";
        case "last_year":
          return "Last year";
        case "custom":
          return this.dateRange;
        default:
          return "Last 15 days";
      }
    },
  },

  methods: {
    onSubmitNewTime(time) {
      this.$router.push({
        path: "/web-analytics",
        query: {
          date_range: time.date_range,
        },
      });
    },
  },
};
</script>
